<template>
  <button
    type="button"
    @click.prevent="isOpenDropdown = !isOpenDropdown"
    v-click-outside="() => (isOpenDropdown = false)"
    class="form-group tag-color-picker-group"
  >
    <label class="form-control-label">Цвет</label>
    <div class="form-control form-control-light custom-color-input">
      <div
        class="color-square"
        :style="{ 'background-color': selectedColor }"
      ></div>
      <div :class="[{ rotated: isOpenDropdown }]">
        <ico name="icoArrowDropDown" />
      </div>
      <div
        @click.stop
        :class="[
          'form-control',
          'form-control-light',
          'custom-color-picker-dropdown',
          { 'custom-color-picker-dropdown-open': isOpenDropdown },
        ]"
      >
        <div
          @click.prevent="selectColor(color)"
          class="color-square"
          v-for="color in colors"
          :key="color"
          :style="{ backgroundColor: color }"
        ></div>
      </div>
    </div>
  </button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TagCustomColorPicker",
  props: {
    selectedColor: {
      type: String,
      required: true,
    },
  },
  emits: ["colorSelected"],
  computed: {
    ...mapGetters("tags", ["colors"]),
  },
  data() {
    return { isOpenDropdown: false };
  },
  methods: {
    selectColor(color) {
      this.$emit("colorSelected", color);
      this.isOpenDropdown = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/commonStyles.less";

.tag-color-picker-group {
  width: max-content;
  margin: 0 !important;

  .custom-color-input {
    width: 70px;
    padding: 0 6px 0 15px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .color-square {
      min-width: 17px;
      min-height: 17px;
      width: 17px;
      height: 17px;
      border-radius: 3px;
      cursor: pointer;
    }

    .rotated {
      transform: rotate(180deg);
    }
  }

  .custom-color-picker-dropdown {
    display: none;
    position: absolute;
    z-index: 999;
    left: -2px;
    top: 53px;
    width: 175px;
    height: 111px;
    background-color: #ffffff;
    padding: 13px;
    box-shadow: 0px 4px 25px 0px #00000040;
    &-open {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 15px;
    }
  }
}
</style>
